import { AllowedChangesItem } from "@repo/api";
import { useMemo } from "react";

type UseAmlAndIdPrerequisitesArgs = {
    allowedChanges?: AllowedChangesItem;
    isChildrenContract?: boolean;
};

export const useAmlAndIdPrerequisites = ({
    allowedChanges,
    isChildrenContract = false,
}: UseAmlAndIdPrerequisitesArgs) => {
    return useMemo(() => {
        if (!allowedChanges) return { needAml: undefined, needIdentification: undefined };

        const needAml = allowedChanges.isAmlFulfilled === false && !isChildrenContract;
        const needIdentification = isChildrenContract
            ? false
            : (allowedChanges.isBankIdIdentificationRequired ?? undefined);

        return { needAml, needIdentification };
    }, [allowedChanges, isChildrenContract]);
};
